import React from 'react';

import {Provider} from 'react-redux';

import {store} from 'app/chat-app/store/ChatAppStore';

import {ChatEnabler} from './components/ChatEnabler';
export const Chat = () => {
  return (
    <Provider store={store}>
      <ChatEnabler />
    </Provider>
  );
};
